import { useEffect, useState } from "react"
import ArrowBackButton from "../../../components/button/ArrowBackButton"
import useHomepageForm from "./useHomepageForm"
import { useParams } from "react-router-dom"
import { Select } from "antd"
import ActionButtonGradient from "../../../components/button/ActionButtonGradient"

const HomepageForm = () => {
    const {
        payload,
        activeOptions,
        previewImage,
        handleSelectStatus,
        handleFileChange,
        onChangeHandler,
        postAnnouncement,
        putAnnouncement,
        getAnnouncement,
        isSaving,
    } = useHomepageForm()
    const [isUpdate, setIsUpdate] = useState(false)
    const [imageTimestamp, setImageTimestamp] = useState(Date.now())
    const params = useParams()

    useEffect(() => {
        if (params.announcement_id) {
            setIsUpdate(true)
            getAnnouncement(params.announcement_id)
            // Update timestamp when loading announcement to bust cache
            setImageTimestamp(Date.now())
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [params.announcement_id])

    return(
        <div className="container-fluid justify-content-center" style={{ 
            maxWidth: '1200px', 
            margin: '0 auto',
            width: '100%',
        }}>
            <div style={{ marginBottom: '24px' }}>
                <ArrowBackButton 
                    title={isUpdate ? "Edit Announcement" : "Create Announcement"} 
                    isTwoSection={true}
                />
            </div>
            
            <div style={{
                backgroundColor: '#ffffff',
                borderRadius: '12px',
                padding: '24px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
                border: '1px solid #f0f0f0'
            }}>
                <h5 style={{ 
                    margin: 0,
                    marginBottom: '24px',
                    fontWeight: 600,
                    color: '#1a1a1a',
                    fontSize: '18px'
                }}>
                    {isUpdate ? "Edit Announcement Information" : "Announcement Information"}
                </h5>

                <form onSubmit={(e) => {isUpdate ? putAnnouncement(e): postAnnouncement(e)}}>
                    <div style={{
                        padding: '20px',
                        backgroundColor: '#f8f9fa',
                        borderRadius: '8px',
                        border: '1px solid #e5e7eb',
                        marginBottom: '24px'
                    }}>
                        <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr', gap: '16px', marginBottom: '24px' }}>
                            <div>
                                <label htmlFor="Title" style={{ 
                                    fontWeight: '600', 
                                    color: '#374151', 
                                    fontSize: '14px',
                                    marginBottom: '8px',
                                    display: 'block'
                                }}>
                                    Title <span style={{color: 'red'}}>*</span>
                                </label>
                                <input 
                                    required
                                    type="text" 
                                    name="Title"
                                    className="form-control" 
                                    id="Title" 
                                    placeholder="Enter announcement title" 
                                    onChange={onChangeHandler}
                                    value={payload.Title}
                                    style={{
                                        padding: '8px 12px',
                                        borderRadius: '6px',
                                        border: '1px solid #d1d5db',
                                        fontSize: '16px'
                                    }}
                                />
                            </div>

                            <div>
                                <label htmlFor="Active" style={{ 
                                    fontWeight: '600', 
                                    color: '#374151', 
                                    fontSize: '14px',
                                    marginBottom: '8px',
                                    display: 'block'
                                }}>
                                    Active Status <span style={{color: 'red'}}>*</span>
                                </label>
                                <Select
                                    required
                                    allowClear
                                    size="large"
                                    style={{
                                        width: '100%'
                                    }}
                                    showSearch={true}
                                    options={activeOptions}
                                    placeholder="Select active status"
                                    onChange={handleSelectStatus}
                                    value={payload.Active}
                                    fontSize="16px"
                                />
                            </div>

                            <div>
                                <label htmlFor="Order" style={{ 
                                    fontWeight: '600', 
                                    color: '#374151', 
                                    fontSize: '14px',
                                    marginBottom: '8px',
                                    display: 'block'
                                }}>
                                    Display Order <span style={{color: 'red'}}>*</span>
                                </label>
                                <input 
                                    required
                                    type="number" 
                                    name="Order"
                                    className="form-control" 
                                    id="Order" 
                                    placeholder="Order" 
                                    onChange={onChangeHandler}
                                    value={payload.Order}
                                    style={{
                                        padding: '8px 12px',
                                        borderRadius: '6px',
                                        border: '1px solid #d1d5db',
                                        fontSize: '16px'
                                    }}
                                />
                            </div>
                        </div>
                        
                        <small style={{ color: '#6c757d', fontSize: '13px', marginTop: '-16px', marginBottom: '16px', display: 'block' }}>
                            Lower numbers will appear first
                        </small>

                        <div className={payload.FileLink ? "mb-4" : "mb-0"}>
                            <label htmlFor="Image" style={{ 
                                fontWeight: '600', 
                                color: '#374151', 
                                fontSize: '14px',
                                marginBottom: '8px',
                                display: 'block'
                            }}>
                                Image {!payload.FileLink && <span style={{color: 'red'}}>*</span>}
                            </label>
                            <input 
                                type="file" 
                                className="form-control" 
                                accept="image/*" 
                                onChange={handleFileChange}
                                style={{
                                    padding: '8px 12px',
                                    borderRadius: '6px',
                                    border: '1px solid #d1d5db',
                                    fontSize: '14px'
                                }}
                            />
                            <small style={{ color: '#6c757d', fontSize: '13px', marginTop: '4px', display: 'block' }}>
                                Recommended: 1920x1080px or 16:9 aspect ratio
                            </small>
                        </div>

                        {(payload.FileLink || previewImage) && (
                            <div className="mb-0">
                                <div style={{
                                    display: 'grid',
                                    gridTemplateColumns: previewImage && payload.FileLink ? '1fr 1fr' : '1fr',
                                    gap: '16px'
                                }}>
                                    {payload.FileLink && (
                                        <div>
                                            <label style={{ 
                                                fontWeight: '600', 
                                                color: '#374151', 
                                                fontSize: '14px',
                                                marginBottom: '8px',
                                                display: 'block'
                                            }}>
                                                {previewImage ? 'Current Image' : 'Preview'}
                                            </label>
                                            <div style={{
                                                width: '100%',
                                                borderRadius: '8px',
                                                overflow: 'hidden',
                                                border: '1px solid #d1d5db',
                                                backgroundColor: '#ffffff'
                                            }}>
                                                <img 
                                                    src={`${payload.FileLink}?t=${imageTimestamp}`} 
                                                    alt={payload.FileName} 
                                                    style={{ 
                                                        width: '100%',
                                                        display: 'block'
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    )}
                                    {previewImage && (
                                        <div>
                                            <label style={{ 
                                                fontWeight: '600', 
                                                color: '#374151', 
                                                fontSize: '14px',
                                                marginBottom: '8px',
                                                display: 'block'
                                            }}>
                                                New Image
                                            </label>
                                            <div style={{
                                                width: '100%',
                                                borderRadius: '8px',
                                                overflow: 'hidden',
                                                border: '2px solid #10b981',
                                                backgroundColor: '#ffffff'
                                            }}>
                                                <img 
                                                    src={previewImage} 
                                                    alt="New preview" 
                                                    style={{ 
                                                        width: '100%',
                                                        display: 'block'
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}
                    </div>

                    <div className="d-flex justify-content-end">
                        { isUpdate ? 
                            <ActionButtonGradient
                                type="submit"
                                variant="primary"
                                disabled={isSaving}
                                children={isSaving ? "Saving..." : "Save Changes"}
                            />
                            :
                            <ActionButtonGradient
                                type="submit"
                                variant="success"
                                disabled={isSaving}
                                children={isSaving ? "Saving..." : "Save Announcement"}
                            />
                        }
                    </div>
                </form>
            </div>
        </div>
    )
}

export default HomepageForm